<div class="zag-tags-input" [class.zag-tags-input--focused]="focused()" [class.zag-tags-input--disabled]="disabled()">
  @for (tag of tags(); track tag + $index; let i = $index) {
  <span class="zag-tags-input__pill" [class.zag-tags-input__pill--invalid]="!isTagValid(tag)">
    <span class="zag-tags-input__pill-text">{{ tag }}</span>
    <button
      type="button"
      class="zag-tags-input__pill-remove"
      [attr.aria-label]="'Remove ' + tag"
      [disabled]="disabled() || null"
      (click)="onPillRemoveClick(i, $event)"
    >
      <span zagIcon="close"></span>
    </button>
  </span>
  }

  <input
    #inputEl
    type="text"
    class="zag-tags-input__input"
    [attr.id]="id()"
    [placeholder]="tags().length === 0 ? placeholder() : ''"
    [disabled]="disabled() || null"
    [attr.aria-describedby]="ariaDescribedby() ?? null"
    (keydown)="onKeydown($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
  />
</div>
